import React from 'react';
import ReactDOM from 'react-dom';

import PropTypes from 'prop-types';
import cx from 'classnames';
import backdropClasses from './Backdrop.module.scss';

export default function Backdrop({ className, children, onClick }) {
  const cs = cx(backdropClasses.backdrop, className);
  const handleOnClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return ReactDOM.createPortal(
    <div
      onClick={handleOnClick}
      aria-hidden="true"
      role="button"
      tabIndex="0"
      className={cs}
    >
      {children}
    </div>,
    document.body,
  );
}

Backdrop.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
};
